module.exports = __webpack_public_path__ + "static/media/PowerOfPeers.b57d490d.jpg";